import { render, staticRenderFns } from "./ProfilePopup.vue?vue&type=template&id=a31e12b2&scoped=true&"
import script from "./ProfilePopup.vue?vue&type=script&lang=js&"
export * from "./ProfilePopup.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePopup.vue?vue&type=style&index=0&id=a31e12b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31e12b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VDivider,VMenu,VSpacer})
